var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#F0F0F0;}\n\t.st3{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.8,426.7C487.3,381.4,512,321.6,512,256s-24.7-125.4-65.2-170.7L256,66.8L65.2,85.3 C24.7,130.6,0,190.4,0,256s24.7,125.4,65.2,170.7L256,445.2L446.8,426.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.2,85.3h381.6C399.9,33,331.8,0,256,0S112.1,33,65.2,85.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,256l256,22.3L512,256c0-29.9-5.2-58.6-14.6-85.3H14.6C5.2,197.4,0,226.1,0,256L0,256z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.6,341.3h482.8c9.4-26.7,14.6-55.4,14.6-85.3H0C0,285.9,5.2,314.6,14.6,341.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M446.8,426.7H65.2C112.1,479,180.2,512,256,512S399.9,479,446.8,426.7L446.8,426.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M341.4,256c0,47.2-38.2,85.4-85.4,85.4s-85.4-38.2-85.4-85.4s38.2-85.4,85.4-85.4S341.4,208.8,341.4,256z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.3,260.4L256,246.8c0,0,7.3-24.3,7.7-26c0.3-1.2,0.4-2.5,0.4-3.8c0-4.6-1.9-8.8-4.9-11.8l7.9-7.9c-5-5-12-8.1-19.7-8.1 s-14.6,3.1-19.7,8.1l7.9,7.9c-3,3-4.9,7.2-4.9,11.8c0,1.7,0.3,3.3,0.7,4.8l-11.8,11.8h21.5c0,0-8.9,13.4-13.8,24.4 c-4.9,11,0.1,24.4,11.3,29.4l6.5,2.9l10.8,10.2v11.1l-11.1,11.1h22.3v-22.3l10.2-10.2h21c0.1-0.2,0.2-0.4,0.3-0.6 C303.6,278.5,298.5,265.3,287.3,260.4L287.3,260.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/ug.7592e52bf2ed13068a60ec53352b16af.svg";
export { ForwardRef as ReactComponent };